import React, { useState } from "react";

const PosIcon = ({ src }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  return (
    <div
      className="p-1"
      src={isFlipped ? src : "/icons/pos.png"}
      onMouseEnter={() => {
        if (src) setIsFlipped(true);
      }}
      onMouseLeave={() => {
        if (src) setIsFlipped(false);
      }}
    >
      <img
        className={"w-12 h-12 rounded-xl bg-neutral-700 p-1 "}
        src={isFlipped ? src : "/icons/pos.png"}
        alt=""
      />
    </div>
  );
};

export default PosIcon;
